// Berry — fiabilise l'ouverture du mega-menu (survol par le bas), avec delai d'intention pour ne pas ouvrir au simple passage
(function () {
  if (window.__berryMenuFix) return;
  window.__berryMenuFix = true;
  var DELAY = 130; // ms de survol continu avant ouverture
  var timer = null;
  var armed = null;
  function cancel() {
    if (timer) { clearTimeout(timer); timer = null; }
    armed = null;
  }
  document.addEventListener('pointermove', function (e) {
    var t = e.target;
    var li = t && t.closest ? t.closest('.menu-list__list-item:not([slot=\"overflow\"])') : null;
    if (!li) { cancel(); return; }
    var a = li.querySelector('[ref=\"menuitem\"]');
    var sub = li.querySelector('.menu-list__submenu');
    if (!sub || !a || a.getAttribute('aria-expanded') === 'true') { cancel(); return; }
    if (armed === li) return; // deja en attente pour cette entree
    cancel();
    armed = li;
    timer = setTimeout(function () {
      timer = null;
      if (armed === li && a.getAttribute('aria-expanded') !== 'true') {
        li.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
      }
      armed = null;
    }, DELAY);
  }, true);
})();